import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function packTypes() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`pack-type/search?${params}`);
    }

    function get(id) {
        return axiosInstance.get(`pack-type/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('pack-type/create', data);
    }

    function update(data) {
        return axiosInstance.patch(`pack-type/update`, data);
    }

    function remove(id) {
        return axiosInstance.delete(`pack-type/delete`, {
            data: {
                id: id
            }
        });
    }
}
